import { render, staticRenderFns } from "./TradeItem.vue?vue&type=template&id=10eb7d33&scoped=true&"
import script from "./TradeItem.vue?vue&type=script&lang=js&"
export * from "./TradeItem.vue?vue&type=script&lang=js&"
import style0 from "./TradeItem.vue?vue&type=style&index=0&id=10eb7d33&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb7d33",
  null
  
)

export default component.exports